const UA = {
    header: {
        title: ['робити', 'просто красиво', ' – замало. Тому я зроблю ', 'гарно, якісно і зручно!'],
        subtitle: 'Розкрию всі переваги вашого бізнесу, завдяки чітко продуманій структурі сайту та естетичному дизайну',
        btn: 'Обговорити проєкт'
    },
    nav: ['Про мене', 'ПОртфоліо', 'етапи роботи', 'ПОСЛУГИ ТА ПРАЙС', 'Консультація', 'Контакти'],
    about: {
        title: 'Про мене',
        content_1: ['Привіт! Мене звати Вікторія, я родом з міста Харків. Все своє життя я прожила там. За фахом я інженер-технолог харчової промисловості, а за покликанням творча людина. Війна змусила мене переосмислити все і почати займатись тим, що мені дійсно подобається.', 'Вебдизайн — це те, що мене надихає і мотивує все глибше пізнавати цю сферу. Тому я з радістю зроблю для тебе стильний та сучасний сайт, який допоможе твоєму бізнесу вийти на новий рівень! 3 Я розробляю сайти під ключ на Readymag та Shopify.', 'А якщо можливостей цих платформ тобі виявиться замало, то я можу розробити дизайн і ми втілимо його на будь-якій іншій платформі завдяки моїй співпраці  з іншими спеціалістами.'],
        content_2: 'Окрім цього можу розробити лого, візитку, підібрати фірмовий стиль, бо цей напрям мені також цікавий. Є ідея — звертайся. 3 Якщо хочеш отримати безкоштовну консультацію, 3 то я з радістю відповім на всі твої питання!',
        quote: 'Вебдизайн — це те, що мене надихає і мотивує!',
        btn: 'Консультація'
    },
};

const ENG = {
    header: {
        title: ['simply', 'doing beautifully', ' is not enough. Therefore, I will make it ', 'beautiful, high-quality and convenient!'],
        subtitle: 'I will reveal all the advantages of your business, thanks to a well-thought-out site structure and aesthetic design',
        btn: 'Discuss the project'
    },
    nav: ['about me', 'portfolio', 'stages of work', 'SERVICES AND PRICE', 'Advice', 'contacts'],
};

const langReducer = ( state = UA, action ) => {
    switch(action.type) {

        case ('eng') : {
            return ENG
        }

        case ('ua') : {
            return UA
        }

        default: {
            return state
        }
    }
}

export default langReducer;